import axiosClient from "./axiosClient";

const study_membersService = {
  inviteInvestigator: (studyId, email) =>
    axiosClient.post(`/study-members/invite`, null, { 
      params: { study_id: studyId, email },
    }),

  getPendingInvitations: (studyId) => axiosClient.get(`/study-members/pending/${studyId}`),

  listInvestigators: (studyId) =>
    axiosClient.get(`/study-members/study/${studyId}`),

  getMyCollaborators: () => axiosClient.get("/study-members/collaborators/mine"),

  getInvestigatorStudyCount:(userId) =>
    axiosClient.get(`/study-members/investigator/${userId}/studies/count`),

  removeInvestigator: (studyId, userId) =>
    axiosClient.delete(`/study-members/study/${studyId}/remove/${userId}`),

  getAvailableUsers: (studyId) =>
    axiosClient.get(`/study-members/available/${studyId}`),

  getInvestigator: (studyId, userId) =>
    axiosClient.get(`/study-members/study/${studyId}/investigator/${userId}`),

  getCollaborator: (userId) =>
    axiosClient.get(`/study-members/collaborator/${userId}`),
};

export default study_membersService;
